import BEM from '@utils/dom/bem';

export const bem = (...args) => BEM.create('SettingsApps', ...args);
